export default function (error, verify, i18n) {
  if (error.response.status === 400) {
    verify(
      error.response.data.message + ' ' + i18n.t('alerts.refreshPage'),
      result => {
        if (result) location.reload()
      }
    )
  }
}
